import { Select } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';
import { useEffect, useState } from 'react';

import { getBookAuthors } from '@/entities/books/api/books-api';
import { Book, BookAuthors } from '@/entities/books/model/types';

type Props = {
  setBookInfo: React.Dispatch<React.SetStateAction<Book>>;
  form: UseFormReturnType<Book>;
};

export const BooksAuthors = ({ setBookInfo, form }: Props) => {
  const [authorsData, setAuthorsData] = useState<BookAuthors[]>([]);

  const authorOptions = authorsData?.map((author) => ({
    value: String(author.id),
    label: author.name,
  }));

  const fetchBookData = async () => {
    try {
      const { authors } = await getBookAuthors();

      setAuthorsData(authors);
    } catch (error) {
      console.error('Error loading data', error);
    }
  };

  useEffect(() => {
    fetchBookData();
  }, []);

  const handleAuthorChange = (value: string | null) => {
    form.setFieldValue('authorId', Number(value));
    setBookInfo((prev) => ({
      ...prev,
      authorId: Number(value),
    }));
  };

  return (
    <Select
      mb={20}
      label="Автор"
      key={form.key('authorId')}
      placeholder="Выберите автора"
      {...form.getInputProps('authorId')}
      value={String(form.values.authorId)}
      data={authorOptions}
      onChange={handleAuthorChange}
      required
    />
  );
};
